/**
 * @author        kyle.agronick@zumper.com (Kyle Agronick)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   Search form component
 */

import type { AutocompleteApiResult, AutocompleteResult } from '@zcode/bizos'
import { SharedMobileAutocompleteInputContainer } from '@zcode/nr/es/shared/components/Autocomplete/MobileAutocompleteInput'
import { SharedAutocomplete } from '@zcode/nr/es/shared/components/Autocomplete/SharedAutocomplete'
import React from 'react'
import css from '../styles/SearchForm.module.scss'
import type { PageNameValues } from '../types'

interface Props {
  dispatchMixpanelAutocompleteResultClick: ({
    result,
    index,
  }: {
    result: AutocompleteApiResult
    index: number
  }) => void
  hideAutocomplete?: boolean
  isFixed?: boolean
  isMobile?: boolean
  fillInputOnSelect?: boolean
  hideMobileAutocomplete?: () => void
  onSelectAutocompleteResult: (result: AutocompleteResult) => void
  pageName?: PageNameValues
  placeholder?: string
  showMobileAutocomplete?: boolean
}

export const SearchForm = ({
  dispatchMixpanelAutocompleteResultClick,
  hideAutocomplete,
  hideMobileAutocomplete,
  isFixed,
  isMobile,
  fillInputOnSelect,
  onSelectAutocompleteResult,
  pageName,
  placeholder = 'Search for apartments in...',
  showMobileAutocomplete,
}: Props) => {
  if (isMobile && !showMobileAutocomplete) {
    return (
      <SharedMobileAutocompleteInputContainer
        hideAutocomplete={hideAutocomplete}
        mobileOrigin={null}
        pageName={pageName}
        placeholder="Where do you want to stay?"
      />
    )
  }

  return (
    <SharedAutocomplete
      dispatchMixpanelAutocompleteResultClick={dispatchMixpanelAutocompleteResultClick}
      fillInputOnSelect={fillInputOnSelect}
      hideMobileAutocomplete={hideMobileAutocomplete}
      isMapListNav
      isShortTerm
      onSelectAutocompleteResult={onSelectAutocompleteResult}
      origin={`origin${isFixed ? '-fixed' : ''}`}
      pageName={pageName}
      placeholder={placeholder}
      showMobileAutocomplete={showMobileAutocomplete}
      theme={css}
    />
  )
}
